import { useAuthStore } from '../stores/authStore';
import type { RoleName, User } from '../types/auth.types';

interface AuthStoreSelectors {
  user: User | null;
  isAuthenticated: boolean;
  isSuperAdmin: boolean;
  isCompanyAdmin: boolean;
  isAgent: boolean;
  isManager: boolean;
  isCompanyScoped: boolean;
  hasRoleFn: (role: RoleName) => boolean;
  activeRole: RoleName | null;
  setActiveRole: (role: RoleName) => void;
  getAvailableRoles: () => RoleName[];
}

export function useAuthStoreSelectors(): AuthStoreSelectors {
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const isSuperAdmin = useAuthStore((state) => state.isSuperAdmin());
  const isCompanyAdmin = useAuthStore((state) => state.isCompanyAdmin());
  const isAgent = useAuthStore((state) => state.isAgent());
  const isManager = useAuthStore((state) => state.isManager());
  const isCompanyScoped = useAuthStore((state) => state.isCompanyScoped());
  const hasRoleFn = useAuthStore((state) => state.hasRole);
  const activeRole = useAuthStore((state) => state.getActiveRole());
  const setActiveRole = useAuthStore((state) => state.setActiveRole);
  const getAvailableRoles = useAuthStore((state) => state.getAvailableRoles);
  return {
    user,
    isAuthenticated,
    isSuperAdmin,
    isCompanyAdmin,
    isAgent,
    isManager,
    isCompanyScoped,
    hasRoleFn,
    activeRole,
    setActiveRole,
    getAvailableRoles,
  };
}
